// Next Imports
// import { Inter } from 'next/font/google'
// import localFont from 'next/font/local'

// MUI Imports
import type { Theme } from '@mui/material/styles'

// Type Imports
import type { Settings } from '@core/contexts/settingsContext'
import type { Skin, SystemMode } from '@core/types'

// Theme Options Imports
import overrides from './overrides'
import colorSchemes from './colorSchemes'
import spacing from './spacing'
import shadows from './shadows'
import customShadows from './customShadows'
import typography from './typography'

// const inter = Inter({ subsets: ['latin'], weight: ['300', '400', '500', '600', '700', '800', '900'] })

// const inter = localFont({
//   src: [
//     {
//       path: '../../../public/fonts/inter/Inter-Light.woff2',
//       weight: '300',
//       style: 'normal'
//     },
//     {
//       path: '../../../public/fonts/inter/Inter-Regular.woff2',
//       weight: '400',
//       style: 'normal'
//     },
//     {
//       path: '../../../public/fonts/inter/Inter-Medium.woff2',
//       weight: '500',
//       style: 'normal'
//     },
//     {
//       path: '../../../public/fonts/inter/Inter-SemiBold.woff2',
//       weight: '600',
//       style: 'normal'
//     },
//     {
//       path: '../../../public/fonts/inter/Inter-Bold.woff2',
//       weight: '700',
//       style: 'normal'
//     },
//     {
//       path: '../../../public/fonts/inter/Inter-ExtraBold.woff2',
//       weight: '800',
//       style: 'normal'
//     },
//     {
//       path: '../../../public/fonts/inter/Inter-Black.woff2',
//       weight: '900',
//       style: 'normal'
//     }
//   ],
//   variable: '--font-inter',
//   display: 'swap'
// })

const theme = (settings: Settings, mode: SystemMode, direction: Theme['direction']): Theme => {
  return {
    direction,
    components: overrides(settings.skin as Skin),
    colorSchemes: colorSchemes(settings.skin as Skin),
    ...spacing,
    shape: {
      borderRadius: 10,
      customBorderRadius: {
        xs: 2,
        sm: 4,
        md: 6,
        lg: 8,
        xl: 10
      }
    },
    shadows: shadows(mode),
    // typography: typography(inter.style.fontFamily),
    typography: typography('Inter, sans-serif'),
    customShadows: customShadows(mode),
    mainColorChannels: {
      light: '38 43 67',
      dark: '234 234 255',
      lightShadow: '38 43 67',
      darkShadow: '16 17 33'
    }
  } as Theme
}

export default theme
